import { motion } from "motion/react"
import { ReactNode } from "react"

const FadeInWhenInView = ({children, delay, margin, classname}: {classname?:string, children: ReactNode, delay: number, margin: number}) => {
    return(
        <motion.div className={"w-full flex flex-col " + classname}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ margin: `${window.innerHeight * -margin}px`, once: true }}
                    transition={{ duration: 0.6, delay: delay }}
                    variants={{
                    visible: { opacity: 1, translateY: '0px' },
                    hidden: { opacity: 0, translateY: window.innerWidth > 800 ? '40px' : '20px' }
                    }}>
            {children}
        </motion.div>

    )

}

export default FadeInWhenInView;